import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=62baf8ae&scoped=true&"
import script from "../../models/communication/comment.ts?vue&type=script&lang=ts&"
export * from "../../models/communication/comment.ts?vue&type=script&lang=ts&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=62baf8ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62baf8ae",
  null
  
)

export default component.exports